<template>
    <!-- 选择图片 -->
    <div class="Minister-top information">
        <div class="Minister-top-top Ministerbackground">
            <div class="Minister-top-left Minister-top-color">图片</div>
        </div>
        <div class="information_content" style="margin-bottom: 20px">
            <div class="mB-20 bts-content">
                <el-button @click="selectOnePicture">产品图片</el-button>
                <el-button @click="delAllImg">清除图片</el-button>
                <ImageTranslation v-if="aiPower && (aiPower + '').split(',').includes('1')" :imgList="productImages" @onTranslation="onTranslation" :targetCountry="targetCountry" :getParentData="getParentData"></ImageTranslation>
            </div>
            <div class="d-f jc-sa ta-c">
                <div v-for="(locator, index) in imageList" :key="locator">
                    <!-- <el-upload :file-list="fileList[locator] || []" :action="upload_url" list-type="picture-card"
                        accept="image/gif, image/jpeg, image/tiff, image/png" :auto-upload="true" :limit="1"
                        :class="{ hide: hideUpload[index] }" :http-request="handleFileUpload"
                        :before-upload="(file) => { return beforeUploadFile(file, index) }"
                        :on-remove="(file, fileList) => { return handleRemove(file, fileList, index) }"
                        :on-success="(response, file, fileList) => { return beforeUploadFileSuccess(response, file, fileList, index) }"
                        :on-preview="handlePictureCardPreview">
                        <i slot="default" class="el-icon-plus"></i>
                    </el-upload> -->
                    <el-upload :file-list="fileList[locator] || []" :action="upload_url" list-type="picture-card"
                        accept="image/gif, image/jpeg, image/tiff, image/png" :limit="imageList.length"
                        :class="{ hide: hideUpload[index] }"
                        :on-success="(response, file, fileList) => { return beforeUploadFile(response, file, fileList, index) }"
                        :on-remove="(file, fileList) => { return handleRemove(file, fileList, index) }"
                        :on-preview="handlePictureCardPreview" :headers="customHeaders">
                        <i slot="default" class="el-icon-plus"></i>
                    </el-upload>
                    <div>{{ imageText[index].titleChinese }}</div>
                    <div class="fun-buttons" v-show="fileList[locator] && fileList[locator].length > 0 && fileList[locator][0]['fanyi_url']">
                        <el-button type="primary" @click="useFanyi(locator)">翻译图</el-button>
                        <el-button type="primary" @click="useYuan(locator)">原图</el-button>
                    </div>
                </div>
            </div>
            <div class="mT-20">
                图片建议 : 商品至少占用图片<span class="red"> 85% </span>的篇幅。图片只能展示出售的商品，可少量包含或不包含其他道具；主图必须为纯白色背景，不能包含其他搭配品；图片尺寸不得小于
                <span class="red">500*1000</span>，不超过 <span class="red">10000*10000</span>；支持 <span
                    class="red">JPEG、TIFF 和 GIF</span> 格式。
            </div>
        </div>
        <el-dialog :visible.sync="dialogVisible" top="5vh" :modal="false">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <xuanze-img v-model="xuanzeShow" :img-list="imgSelectList" @confirm="onConfirmByXuanzeImg"></xuanze-img>
    </div>
</template>
<script>
import { ajaxGet, ajaxPost, Baseurl } from "@/api/api/api";
import XuanzeImg from "./xuanzeImg.vue";
import ImageTranslation from '@/components/ImageTranslation/index.vue';
export default {
    components: {
        XuanzeImg,
        ImageTranslation
    },
    data() {
        return {
            dialogVisible: false,
            xuanzeShow: false,
            dialogImageUrl: '',
            imgSelectList: [],
            fileList: {},
            imageList: [],
            imageText: [],
            hideUpload: [],
            upload_url: Baseurl + "xgImage/uploadImage",
            deleteFiles: [],
            customHeaders: { token: localStorage.getItem("token") },
            productImages: [],
            targetCountry: '',
        };
    },
    props: {
        publishInfo: {
            type: Object,
            default: () => ({})
        },
        isChakan: {
            type: Boolean,
            default: false,
        },
        system: {
            type: Number,
            default: 5,
        },
        areaName: {
            type: String
        },
        aiPower:{},
    },
    mounted() {
        this.setFileList()
    },
    methods: {
        useFanyi(key){
            this.$set(this.fileList[key][0], 'url', this.fileList[key][0]['fanyi_url']);
        },
        useYuan(key){
            this.$set(this.fileList[key][0], 'url', this.fileList[key][0]['yuan_url']);
        },
        getParentData(){
            const imgData = [];
            for(let i = 0; i < this.imageList.length; i++){
                const k = this.imageList[i];
                if(this.fileList[k] && this.fileList[k].length > 0){
                    imgData.push({
                        src: this.fileList[k][0].url
                    })
                }
            }
            return imgData;
        },
        setTargetCountry(){
            this.targetCountry = this.areaName;
        },
        onTranslation(res){
            if(res && res.length > 0){
                const obj = {};
                for(let i = 0; i < res.length; i++){
                    obj[res[i].sourceImg] = res[i].res.data;
                }
                for(let k in this.fileList){
                    if(this.fileList[k] && this.fileList[k].length > 0){
                        const url1 = this.fileList[k][0]['url'];
                        if(obj[url1]){
                            this.$set(this.fileList[k][0], 'url', obj[url1]);
                            this.$set(this.fileList[k][0], 'fanyi_url', obj[url1]);
                            this.$set(this.fileList[k][0], 'yuan_url', url1);
                        }
                    }
                }
            }
        },
        getData() {
            // 返回所有当前 data
            return { ...this.$data };
        },
        resetData() {
            // 用 Object.assign 替换 this 上的数据为初始状态
            Object.assign(this.$data, this.$options.data.call(this));
        },
        selectOnePicture() {
            this.xuanzeShow = true
        },
        onConfirmByXuanzeImg(img) {
            let imageLocators = null;
            for (let index = 0; index < this.imageList.length; index++) {
                imageLocators = this.imageList[index]
                this.fileList[imageLocators] = []
                this.hideUpload[index] = false
            }
            for (let index = 0; index < img.length; index++) {
                imageLocators = this.imageList[index]
                if (this.fileList[imageLocators].length == 0) {
                    this.fileList[imageLocators].push({
                        name: imageLocators,
                        url: img[index]
                    })
                    this.hideUpload[index] = true
                }
            }
        },
        fileListInit() {
            this.hideUpload = []
            let imageLocators = null;
            for (let index = 0; index < this.imageList.length; index++) {
                this.hideUpload.push(false)
                imageLocators = this.imageList[index]
                this.fileList[imageLocators] = [];
            }
        },
        setFileList() {
            this.fileList = {}
            this.fileListInit()
            this.imageList = []
            this.fileList = {
                "main_product_image_locator": [],
                "other_product_image_locator_1": [],
                "other_product_image_locator_2": [],
                "other_product_image_locator_3": [],
                "other_product_image_locator_4": [],
                "other_product_image_locator_5": [],
                "other_product_image_locator_6": [],
                "other_product_image_locator_7": [],
                "other_product_image_locator_8": [],
                "swatch_product_image_locator": []
            }
        },
        beforeUploadFile(response, file, fileList, index) {
            this.hideUpload[index] = true
            this.fileList[this.imageList[index]] = [{ name: file.name, url: file.response.data }]
        },
        handleRemove(file, fileList, index) {
            // 这里处理移除图片的逻辑
            this.$nextTick(() => {
                this.hideUpload[index] = false
                this.fileList[this.imageList[index]] = []
                let deleteImage = (file.url.lastIndexOf('/') + 1)
                deleteImage = file.url.substring(deleteImage, file.url.length)
                this.deleteFiles.push(deleteImage)
                this.deleteFiles = []
            })
        },
        handlePictureCardPreview(file) {
            this.dialogVisible = true
            this.dialogImageUrl = file.url
        },
        // 清除所有图片
        delAllImg() {
            this.fileListInit()
        },
    },
};
</script>
<style lang="scss" scoped>
@import "../../../AllegroProductAllegro/ozon.less";
@import '../../../../style/common.css';

.red {
    color: red;
}

.select {
    width: 40px;
    line-height: 30px;
    height: 30px;
    border-radius: 10px;
    position: absolute;
    top: 0;
    left: 110px;
    background-color: rgb(42, 250, 42);
    box-shadow: 0px 2px 7px 0px rgba(85, 110, 97, 0.35);
}

.hide /deep/ .el-upload--picture-card {
    display: none;
}

::v-deep .el-upload-list__item {
    transition: none !important;
}
.bts-content{
    display: flex;
    align-items: center;
    .ImageTranslation-container{
        margin-left: 20px;
    }
}
.fun-buttons{
    margin-top: 10px;
}
</style>
